import React,
{
  useCallback,
  useEffect,
  useState
} from 'react'
import { useQuery } from 'react-query'
import { useDispatch } from 'react-redux'
import {
  useHistory,
  useParams
} from 'react-router'

import {
  Button,
  IconButton
} from '@driftt/tide-core'
import { showTransientNotification } from '@driftt/traffic-control'
import {
  getMergeCandidate,
  getNextCandidate,
  mergeContact
} from 'api/contacts'
import MergeTool from 'components/MergeTool'

import './style.css'

const Merge = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { email: emailParam } = useParams()
  const [email, setEmail] = useState(null)
  const [excludedEmails, setExcludedEmails] = useState(['test+endusersmoketest@example.com'])
  const [loadingMerge, setLoadingMerge] = useState(false)
  const isWizard = emailParam === 'all'

  const mergeSubmission = useCallback(async (preview) => {
    try {
      setLoadingMerge(true)
      await mergeContact({
        email,
        preview
      })
      setTimeout(() => (
        dispatch(showTransientNotification({
          type: 'success',
          message: `Successfully merged ${preview.duplicates.length + 1} contacts into ${email}`
        }))
      ), 500)
    } catch (err) {

    }
  }, [email, dispatch])


  const getNextEmail = useCallback(async () => {
    try {
      const { data } = await getNextCandidate({ excludedEmails })
      setEmail(data)
    } catch (err) {
    }
  }, [excludedEmails])


  const mergeAndClose = useCallback(async (data) => {
    try {
      await mergeSubmission(data)
      history.push('/duplicates')
    } catch (err) {

    }
  }, [history, mergeSubmission])


  const mergeAndNext = useCallback(async (data) => {
    try {
      await mergeSubmission(data)
      setEmail(null)
      await getNextEmail()
    } catch (err) {

    }
  }, [mergeSubmission, getNextEmail])

  const skipPreview = useCallback(async () => {
    try {
      setExcludedEmails([...excludedEmails, email])
      setEmail(null)
      await getNextEmail()
    } catch (err) {

    }
  }, [email, excludedEmails, getNextEmail])


  const {
    isFetching = true,
    error: previewError,
    data = {},
    isSuccess = false,
    isLoading
  } = useQuery([`merge-preview:${email}`, email],
    () => (
      getMergeCandidate({ email })
        .then(({ data }) => data)
    ), {
      enabled: !!email,
      retry: false,
      staleTime: 600000 //10s in ms
    })


  useEffect(() => {
    if (isWizard) {
      getNextEmail()
    } else {
      setEmail(emailParam)
    }
  }, [emailParam, getNextEmail, isWizard])

  return(
    <div className="crm-merge-tool">
      <header>
        <h1>Merge contacts</h1>

        <IconButton
          icon="close"
          onClick={() => history.push('/duplicates')}
          className="crm-merge-tool-close"
        />
      </header>

      <MergeTool
        email={email}
        mergedContact={data.mergedContact}
        references={data.references}
        duplicates={data.duplicates}
        unusedDuplicates={data.unusedDuplicates}
        isFetching={isFetching}
        previewError={previewError}
        isSuccess={!!email && isSuccess}
        isLoading={isLoading}
      />

      <footer>
        {!isWizard && (
          <Button
            loading={loadingMerge}
            onClick={() => mergeAndClose(data)}
          >
          Merge contact
          </Button>
        )}
        {isWizard && (
          <>
          <Button
            loading={loadingMerge}
            onClick={() => mergeAndNext(data)}
          >
          Merge and continue
          </Button>

          <Button
            loading={loadingMerge}
            onClick={() => skipPreview()}
            type="tertiary"
          >
          Skip
          </Button>
          </>
        )}
      </footer>
    </div>
  )
}

export default Merge
